import { Link } from "react-router-dom";

export const SidebarItem = ({
  icon,
  label,
  to,
  active = false,
  muted = false,
  onClick,
}) => (
  <Link
    to={to}
    onClick={onClick}
    className={[
      "vn-item",
      active ? "is-active" : "",
      muted ? "is-muted" : "",
    ].join(" ")}
  >
    <span className="vn-item-icon">
      {typeof icon === "string" ? <img src={icon} alt="" /> : icon}
    </span>
    <span className="vn-item-label">{label}</span>
  </Link>
);
